import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./UserRow.module.css";

interface UserRowProps {
  _id: string;
  name: string;
  email: string;
  outstandingBalance: number;
  lastLoginAt: string | null;
  createdAt: string;
}

const UserRow: React.FC<UserRowProps> = ({
  _id,
  name,
  email,
  outstandingBalance,
  lastLoginAt,
  createdAt,
}) => {
  const history = useHistory();

  const formatDate = (date: string | null) => {
    if (!date) return "Nigdy";

    return new Date(date).toLocaleDateString("pl-PL");
  };

  const formatDateTime = (date: string | null) => {
    if (!date) return "Nigdy";

    return new Date(date).toLocaleString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div
      className={styles.Row}
      onClick={() => history.push(`/admin/users/${_id}`)}
    >
      <div className={styles.User}>
        <div className={styles.Name}>{name}</div>
        <div className={styles.Email}>{email}</div>
      </div>

      <div className={styles.Amount}>
        <span className={styles.MobileLabel}>
          Do zapłaty:
        </span>
        {outstandingBalance.toFixed(2)} PLN
      </div>

      <div className={styles.LastLogin}>
        <span className={styles.MobileLabel}>
          Ostatnie logowanie:
        </span>
        {formatDateTime(lastLoginAt)}
      </div>

      <div className={styles.Created}>
        <span className={styles.MobileLabel}>
          Rejestracja:
        </span>
        {formatDate(createdAt)}
      </div>
    </div>
  );
};

export default UserRow;